import React from "react";
import {
  MW_HELP_EXAMPLE_PROMPTS,
  MW_HELP_INTRO,
  MW_HELP_LABELS,
  MW_HELP_LIMITS,
} from "../utils/triloChatHelpContent";

/**
 * TriloChatHelpPanel
 *
 * "How to use MW" overlay. The copy lives in utils/triloChatHelpContent.js so
 * it can be edited without touching this markup.
 *
 * Props:
 * - onClose: () => void
 */
const TriloChatHelpPanel = ({ onClose }) => (
  <div className="trilochat__help-overlay" onClick={onClose}>
    <div className="trilochat__help-panel" onClick={e => e.stopPropagation()}>
      <div className="trilochat__help-header">
        <h2>How to use MW</h2>
        <button
          className="trilochat__help-close"
          onClick={onClose}
          aria-label="Close">
          ✕
        </button>
      </div>
      <div className="trilochat__help-body">
        <p className="trilochat__help-intro">{MW_HELP_INTRO}</p>

        <div className="trilochat__help-section">
          <h3>Labels</h3>
          <div className="trilochat__help-labels">
            {MW_HELP_LABELS.map(({ tag, label, description }) => (
              <div key={tag} className="trilochat__help-label">
                <span
                  className={`trilochat__help-label-tag trilochat__help-label-tag--${tag}`}>
                  {label}
                </span>
                <span>{description}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="trilochat__help-section">
          <h3>Example prompts</h3>
          <div className="trilochat__help-examples">
            {MW_HELP_EXAMPLE_PROMPTS.map(({ heading, prompts }) => (
              <div key={heading} className="trilochat__help-example-group">
                <h4>{heading}</h4>
                <ul>
                  {prompts.map(q => (
                    <li key={q}>
                      <em>{q}</em>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="trilochat__help-section">
          <h3>Drafts &amp; export</h3>
          <p>
            When MW composes a passage ready for your CSR, it appears as a draft
            card below the message. You can <strong>Accept</strong> it or{" "}
            <strong>Edit</strong> it. Use <strong>Export PDF</strong> in the
            header to download a PDF with all accepted drafts and the
            conversation findings.
          </p>
          <p>
            Every number in a draft is automatically checked against the data
            returned during the session. If a number cannot be verified, the
            draft card shows a warning listing the specific values to check
            before use.
          </p>
        </div>

        <div className="trilochat__help-section trilochat__help-section--limits">
          <h3>What MW will not do</h3>
          <ul>
            {MW_HELP_LIMITS.map(limit => (
              <li key={limit}>{limit}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default TriloChatHelpPanel;
